import React, { Component } from "react";
import { injectIntl, defineMessages } from "react-intl";
import { Message, List } from "semantic-ui-react";

import { Button, ModalTemplate, Loading } from "components";
import "./ConfigSync.css";

class ConfigSync extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { formatMessage } = this.props.intl;
    const {
      onProgress,
      targetSync,
      onToggleModal,
      showModal,
      resultMessage,
    } = this.props;

    let syncResult = null;
    let syncSuccess = null;
    if (resultMessage.fail) {
      syncResult = resultMessage.fail;
    } else {
      const resultData = resultMessage.success;
      if (!!resultData["noService"]) {
        syncResult = defineMessages(
          formatMessage({
            id: "ConfigLDAP_12",
            defaultMessage: "존재하지 않는 ServiceNo 입니다.",
          })
        );
      } else if (!!resultData["noConnect"] || !!resultData["noModule"]) {
        syncResult = defineMessages(
          formatMessage({
            id: "ConfigSync_3",
            defaultMessage: "입력하신 연동 정보가 올바르지 않습니다.",
          })
        );
      } else {
        syncResult = defineMessages(
          formatMessage({
            id: "ConfigSync_4",
            defaultMessage: "대상자 수동 연동 결과",
          })
        );
        syncSuccess = (
          <Message className={"template-detail-box"}>
            <div className={"template-detail"}>
              <List bulleted className={"template-detail-list"}>
                {!!resultData["serviceNo"] && (
                  <List.Item className={"template-detail-item"}>
                    <div className={"template-detail-item-title"}>
                      {defineMessages(
                        formatMessage({
                          id: "ConfigLDAP_7",
                          defaultMessage: "서비스No",
                        })
                      )}
                    </div>
                    {resultData["serviceNo"]}
                  </List.Item>
                )}
                {!!resultData["serviceName"] && (
                  <List.Item className={"template-detail-item"}>
                    <div className={"template-detail-item-title"}>
                      {defineMessages(
                        formatMessage({
                          id: "ConfigLDAP_8",
                          defaultMessage: "서비스명",
                        })
                      )}
                    </div>
                    {resultData["serviceName"]}
                  </List.Item>
                )}
                {!!resultData["serviceOwner"] && (
                  <List.Item className={"template-detail-item"}>
                    <div className={"template-detail-item-title"}>
                      {defineMessages(
                        formatMessage({
                          id: "ConfigLDAP_9",
                          defaultMessage: "사용자",
                        })
                      )}
                    </div>
                    {resultData["serviceOwner"]}
                  </List.Item>
                )}
                {!!resultData["regDate"] && (
                  <List.Item className={"template-detail-item"}>
                    <div className={"template-detail-item-title"}>
                      {defineMessages(
                        formatMessage({
                          id: "ConfigLDAP_10",
                          defaultMessage: "등록일시",
                        })
                      )}
                    </div>
                    {resultData["regDate"]}
                  </List.Item>
                )}
                {resultData["alreadyExist"] > 0 && (
                  <List.Item className={"template-detail-item"}>
                    <div className={"template-detail-item-title"}>
                      {defineMessages(
                        formatMessage({
                          id: "ConfigLDAP_2",
                          defaultMessage: "유지 대상자",
                        })
                      )}
                    </div>
                    {resultData["alreadyExist"]}명
                  </List.Item>
                )}
                {resultData["addCount"] > 0 && (
                  <List.Item className={"template-detail-item"}>
                    <div className={"template-detail-item-title"}>
                      {defineMessages(
                        formatMessage({
                          id: "ConfigLDAP_3",
                          defaultMessage: "추가 대상자",
                        })
                      )}
                    </div>
                    {resultData["addCount"]}명
                  </List.Item>
                )}
                {resultData["editCount"] > 0 && (
                  <List.Item className={"template-detail-item"}>
                    <div className={"template-detail-item-title"}>
                      {defineMessages(
                        formatMessage({
                          id: "ConfigLDAP_4",
                          defaultMessage: "변경 대상자",
                        })
                      )}
                    </div>
                    {resultData["editCount"]}명
                  </List.Item>
                )}
                {resultData["deleteCount"] > 0 && (
                  <List.Item className={"template-detail-item"}>
                    <div className={"template-detail-item-title"}>
                      {defineMessages(
                        formatMessage({
                          id: "ConfigLDAP_5",
                          defaultMessage: "삭제 대상자",
                        })
                      )}
                    </div>
                    {resultData["deleteCount"]}명
                  </List.Item>
                )}
                {resultData["errorCount"] > 0 && (
                  <List.Item className={"template-detail-item"}>
                    <div className={"template-detail-item-title"}>
                      {defineMessages(
                        formatMessage({
                          id: "ConfigLDAP_6",
                          defaultMessage: "실패 대상자",
                        })
                      )}
                    </div>
                    {resultData["errorCount"]}명
                  </List.Item>
                )}
              </List>
            </div>
          </Message>
        );
      }
    }

    return (
      <div className="config-sync-wrap">
        {/* 대상자 수동 연동 모달 */}
        {showModal && (
          <ModalTemplate
            closeOnEscape={false}
            closeOnDimmerClick={false}
            className={("modal-admin tiny", "common-content")}
            visible
            onToggleModal={onToggleModal}
            header={
              <div>
                {defineMessages(
                  formatMessage({
                    id: "ConfigSync_2",
                    defaultMessage: "대상자 수동 연동",
                  })
                )}
              </div>
            }
            buttons={
              <div className={"inline-block"}>
                <Button
                  buttonColor="#bbbbbb"
                  onClick={() => {
                    onToggleModal(false);
                  }}
                >
                  {defineMessages(
                    formatMessage({
                      id: "StartExamWizardButton_4",
                      defaultMessage: "확 인",
                    })
                  )}
                </Button>
              </div>
            }
          >
            <Loading active={onProgress} size="small" content="Waiting..." />
            <div className="message-header">{syncResult}</div>
            {syncSuccess}
          </ModalTemplate>
        )}

        {/* 대상자 수동 연동 버튼 */}
        <div className={"config-button-box"}>
          <Button
            className={"bt-style-gleam common-button-brand"}
            size="small"
            loading={onProgress}
            disabled={onProgress}
            content={defineMessages(
              formatMessage({
                id: "ConfigSync_2",
                defaultMessage: "대상자 수동 연동",
              })
            )}
            onClick={targetSync}
          />
        </div>
      </div>
    );
  }
}
export default injectIntl(ConfigSync);



// WEBPACK FOOTER //
// ./src/script/components/config/ConfigSync.js